// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__31BJw","signatureBlock":"Footer_signatureBlock__2Q9Jc","signature":"Footer_signature__152WV"};